import { Pencil, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { fmtDate, promptInfo } from "@/lib/aba";
import { SESSIONS } from "@/constants/testIds";

export const PromptChip = ({ prompt }) => {
  const info = promptInfo(prompt);
  return (
    <span className="inline-flex items-center gap-1.5 text-xs" title={info.label}>
      <span className="h-5 w-5 rounded-full border-2 text-[10px] font-bold flex items-center justify-center bg-white" style={{ borderColor: info.color, color: info.color }}>{info.code}</span>
      <span className="hidden lg:inline text-muted-foreground">{info.short}</span>
    </span>
  );
};

export const SessionsTable = ({ points = [], criterio = 80, onEdit, onDelete, compact = false }) => {
  if (!points.length) return null;
  const rows = compact ? [...points] : [...points].sort((a, b) => b.numero - a.numero);
  const editable = Boolean(onEdit || onDelete);
  return (
    <div className="rounded-xl border border-border overflow-hidden bg-card" data-testid={SESSIONS.table}>
      <Table className={compact ? "text-xs" : ""}>
        <TableHeader>
          <TableRow className="bg-muted/50 hover:bg-muted/50">
            <TableHead className="w-12">N.</TableHead>
            <TableHead>Data</TableHead>
            <TableHead className="text-right">Corrette / Totale</TableHead>
            <TableHead className="text-right">%</TableHead>
            <TableHead className="text-right">Cum.</TableHead>
            <TableHead>Prompt</TableHead>
            <TableHead>Fase</TableHead>
            <TableHead className={compact ? "" : "hidden md:table-cell"}>Note</TableHead>
            {editable && <TableHead className="w-24 text-right no-print"><span className="sr-only">Azioni</span></TableHead>}
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((p) => (
            <TableRow key={p.session_id} data-testid={`session-row-${p.numero}`}>
              <TableCell className="font-heading font-semibold tabular">{p.numero}</TableCell>
              <TableCell className="whitespace-nowrap">{fmtDate(p.data)}</TableCell>
              <TableCell className="text-right tabular">{p.corrette} / {p.totale}</TableCell>
              <TableCell className="text-right">
                <span className={`inline-flex min-w-[52px] justify-end font-semibold tabular ${p.percentuale >= criterio ? "text-emerald-700" : "text-foreground"}`}>{p.percentuale}%</span>
              </TableCell>
              <TableCell className="text-right tabular text-muted-foreground">{p.cumulativo}</TableCell>
              <TableCell><PromptChip prompt={p.prompt} /></TableCell>
              <TableCell>
                <span className={`text-xs font-medium ${p.fase === "acquisito" ? "text-emerald-700" : "text-primary"}`}>{p.fase === "acquisito" ? "Acquisito" : "Introdotto"}</span>
              </TableCell>
              <TableCell className={`${compact ? "" : "hidden md:table-cell"} text-muted-foreground text-sm max-w-[280px] truncate`} title={p.note}>{p.note || "—"}</TableCell>
              {editable && (
                <TableCell className="text-right no-print">
                  <div className="flex justify-end gap-1">
                    <Button variant="ghost" size="icon" className="h-8 w-8" onClick={() => onEdit(p)} aria-label="Modifica sessione" data-testid={`session-edit-${p.numero}`}><Pencil className="h-4 w-4" /></Button>
                    <Button variant="ghost" size="icon" className="h-8 w-8 text-destructive hover:text-destructive" onClick={() => onDelete(p)} aria-label="Elimina sessione" data-testid={`session-delete-${p.numero}`}><Trash2 className="h-4 w-4" /></Button>
                  </div>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
